// ProjectPhaseStatus Component

/* eslint indent: 0, react/jsx-indent: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import Tab from '../../../common/layout/tab/tab.jsx'
import TabPanel from '../../../common/layout/tab_panel/tab_panel.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import FormDatePicker from '../../../common/form/form_datepicker/form_datepicker.jsx'
import FormButton from '../../../common/form/button/button.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import Acl from '../../../lib/acl.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'

class ProjectPhaseStatus extends Component {
  constructor (props) {
    super(props)

    const currDate = DateUtil.getUTCCurrentDate()
    this.data = {
      infoData: [
        'project.form.textCreateBudget',
        'project.form.textCreateEstimate',
        'project.form.textTrackTime',
        'project.form.textShowTasks',
        'project.form.textBookExpense',
        'project.form.textCreateInvoice'
      ],

      tabIndex: props.value ? this._getTabIndex(props.value) : 1,
      closeDate: {
        bToday: !!(
          props.closeDate &&
          DateUtil.isDateEqual(currDate, new Date(props.closeDate))
        ),
        date: props.closeDate ? new Date(props.closeDate) : ''
      },
      projectStatus: props.projectStatus ? props.projectStatus : '',
      showConfirmation: false,
      lastClosedPhaseIdx: null,
      lastClosedStatusObj: null,
      phases: props.phases ? props.phases : []
    }
  }

  static get propTypes () {
    return {
      onChangePhaseStatus: PropTypes.func,
      onChangeProjectStatus: PropTypes.func,
      disableEsimateStatus: PropTypes.bool,
      value: PropTypes.string,
      closeDate: PropTypes.any,
      projectStatus: PropTypes.string,
      phases: PropTypes.array
    }
  }

  static get defaultProps () {
    return {
      onChangePhaseStatus: null,
      onChangeProjectStatus: null,
      bPhase: false,
      disableEsimateStatus: false,
      value: '',
      closeDate: null,
      phases: [],
      projectStatus: ''
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (this.data.projectStatus !== nextProps.projectStatus) {
      this.data.projectStatus = nextProps.projectStatus

      this.setState({ dataDate: new Date() })
    }

    if (this.data.phases !== nextProps.phases) {
      this.data.phases = nextProps.phases

      this.setState({ dataDate: new Date() })
    }
  }

  render () {
    return (
      <div className='project-phasestatus'>
        <div className='status-content'>{this._renderTab()}</div>
        {this._renderCloseDate()}
      </div>
    )
  }

  /* Event Handlers */
  _handleProjectStatusChange (projectIdx) {
    if (projectIdx === 0) {
      this.data.projectStatus = 'estimate'
    } else if (projectIdx === 1) {
      this.data.projectStatus = 'active'
    } else if (projectIdx === 2) {
      this.data.projectStatus = 'completed'
      this._changePhasesStatus('completed')
    } else if (projectIdx === 3) {
      this.data.projectStatus = 'closed'
      this._changePhasesStatus('closed')
    }

    if (
      (this.props.onChangeProjectStatus,
      this.data.projectStatus && this.data.projectStatus !== 'closed')
    ) {
      this.props.onChangeProjectStatus(this.data.projectStatus, null)
    }

    this.setState({ dataDate: new Date() })
  }

  _changePhasesStatus (status) {
    if (this.data.phases.length > 0) {
      this.data.phases.map(phase => {
        phase.status = status
      })
    }
  }

  _handlePhaseChange (phaseIdx, tabIndex) {
    const phase = this.data.phases[phaseIdx]
    const statusObj = this._getStatusObject(tabIndex)
    phase.status = statusObj.status

    this._updateProjectStatus(this.data.phases)

    let closedStatusPhases = 0
    this.data.phases.map(phase => {
      if (phase.status === 'closed') {
        closedStatusPhases++
      }
    })

    if (this.data.phases.length !== closedStatusPhases) {
      this.props.onChangePhaseStatus(phaseIdx, statusObj)
    } else {
      this.data.lastClosedPhaseIdx = phaseIdx
      this.data.lastClosedStatusObj = statusObj
    }
    this.setState({ dataDate: new Date() })
  }

  _getStatusObject (tabIndex) {
    if (tabIndex === 0) {
      return { status: 'estimate', closeDate: '' }
    } else if (tabIndex === 1) {
      return { status: 'active', closeDate: '' }
    } else if (tabIndex === 2) {
      return { status: 'completed', closeDate: '' }
    }

    return {
      status: 'closed',
      closeDate:
        this.data.closeDate && this.data.closeDate.date
          ? new Date(this.data.closeDate.date)
          : new Date()
    }
  }

  _updateStatus () {
    const lastClosedPhaseIdx = this.data.lastClosedPhaseIdx
    const lastClosedStatusObj = this.data.lastClosedStatusObj

    if (
      lastClosedPhaseIdx !== null &&
      lastClosedStatusObj &&
      this.props.onChangePhaseStatus &&
      this.data.projectStatus !== 'closed'
    ) {
      this.props.onChangePhaseStatus(
        lastClosedPhaseIdx,
        lastClosedStatusObj,
        this.data.closeDate && this.data.closeDate.date
          ? new Date(this.data.closeDate.date)
          : new Date()
      )
    } else if (this.data.projectStatus === 'closed') {
      this.props.onChangeProjectStatus(
        'closed',
        this.data.closeDate && this.data.closeDate.date
          ? new Date(this.data.closeDate.date)
          : new Date()
      )
    }
  }

  _onChangeDate (name, value) {
    const dateInfo = this.data[name] || {}
    dateInfo.date = value

    this.data.closeDate = dateInfo
    this.data.showConfirmation = true
    this._refresh()
  }

  _onClickDate (name, value, ev) {
    ev.preventDefault()

    const curDate = DateUtil.getUTCCurrentDate()
    const info = {}
    if (value === 'today') {
      info.bToday = true
      info.date = curDate
    } else if (value === 'yesterday') {
      info.bToday = false
      info.date = new Date(
        curDate.getFullYear(),
        curDate.getMonth(),
        curDate.getDate() - 1,
        curDate.getHours(),
        curDate.getMinutes(),
        curDate.getSeconds()
      )
    } else if (value === 'noDate') {
      info.bToday = false
      info.date = ''
    }

    this.data.closeDate = info
    this.data.showConfirmation = true
    this._refresh()
  }

  _onClickConfirm (ev) {
    ev.preventDefault()
    this._updateStatus()
  }

  _refresh () {
    this.setState({ dataDate: new Date() })
  }

  _onClickPhaseRow (_phaseIdx) {
    this.setState({ dataDate: new Date() })
  }

  /* Private functions */
  _renderStatusLabel () {
    return (
      <div className='statuslabel'>
        <div className='labelcont'>{this._renderLableRow()}</div>
      </div>
    )
  }

  _renderLableRow () {
    if (this.data.infoData && this.data.infoData.length > 0) {
      return this.data.infoData.map((info, idx) => {
        return (
          <div className='labelrow' key={idx}>
            <IntlMessage ident={info} />
          </div>
        )
      })
    }

    return ''
  }

  _renderTab () {
    const tabIndex = this._getTabIndexFromStatus(this.data.projectStatus)

    const statusEstimateCls = tabIndex === 0 ? 'item active' : 'item'
    const statusActiveCls = tabIndex === 1 ? 'item active' : 'item'
    const statusCompleteCls = tabIndex === 2 ? 'item active' : 'item'
    const statusClosedCls = tabIndex === 3 ? 'item active' : 'item'

    return (
      <div className='contentwrap'>
        <div className='cont'>
          <div className='contheader'>
            <div className='phaseheader'>
              <div className='labelheader' />
              <Tab
                showAll
                showFullBorder
                onChange={this._handleProjectStatusChange.bind(this)}
              >
                <TabPanel
                  title='project.form.stepStatusEstimate'
                  disable={tabIndex !== 0}
                  active={tabIndex === 0}
                />
                <TabPanel
                  title='project.form.stepStatusActive'
                  disable={tabIndex !== 1}
                  active={tabIndex === 1}
                />
                <TabPanel
                  title='project.form.stepStatusCompleted'
                  active={tabIndex === 2}
                />
                <TabPanel
                  title='project.form.stepStatusClosed'
                  active={tabIndex === 3}
                />
              </Tab>
            </div>
          </div>
          {this.data.phases && this.data.phases.length > 0 && (
            <div className='phases'>
              <div className='phasecontainer'>{this._renderPhaseTabs()}</div>
            </div>
          )}
          <div className='btmcont'>
            {this._renderStatusLabel()}
            <div className='checkcont'>
              <div className={statusEstimateCls}>
                {this._rendeStatusActions([0, 1, 4, 5])}
              </div>
              <div className={statusActiveCls}>
                {this._rendeStatusActions([0, 1, 2, 3, 4, 5])}
              </div>
              <div className={statusCompleteCls}>
                {this._rendeStatusActions([0, 1, 3, 4, 5])}
              </div>
              <div className={statusClosedCls}>
                {this._rendeStatusActions([])}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _renderPhaseTabs () {
    let tabIndex = 0

    if (this.data.phases) {
      return this.data.phases.map((phase, idx) => {
        tabIndex = this._getTabIndexFromStatus(phase.status)

        if (!phase.title) {
          phase.title = `${IntlUtil.convertMessage(
            'expense.form.phaseLabel'
          )} ${idx + 1}`
        }

        return (
          <div key={idx}>
            <div className='phaselabel'>{phase.title}</div>
            <Tab
              showAll
              showFullBorder
              onChange={this._handlePhaseChange.bind(this, idx)}
            >
              <TabPanel
                title='project.form.stepStatusEstimate'
                active={tabIndex === 0}
                disable={phase.disableEstimate}
              />
              <TabPanel
                title='project.form.stepStatusActive'
                active={tabIndex === 1}
                disable={!this._isActiveStatusEnabled(phase.status)}
              />
              <TabPanel
                title='project.form.stepStatusCompleted'
                active={tabIndex === 2}
                disable={!this._isCompleteStatusEnabled(phase.status)}
              />
              <TabPanel
                title='project.form.stepStatusClosed'
                active={tabIndex === 3}
                disable={!(phase.status !== 'closed')}
              />
            </Tab>
          </div>
        )
      })
    }
  }

  _getTabIndexFromStatus (status) {
    let tabIndex = 0
    if (status === 'estimate') {
      tabIndex = 0
    } else if (status === 'active') {
      tabIndex = 1
    } else if (status === 'completed') {
      tabIndex = 2
    } else if (status === 'closed') {
      tabIndex = 3
    }

    return tabIndex
  }

  _rendeStatusActions (activeSteps) {
    return this.data.infoData.map((info, idx) => {
      const bActive = _.indexOf(activeSteps, idx) >= 0
      const _statCls = classnames('status', {
        complete: bActive
      })

      let statusIcon = ''
      if (bActive) {
        statusIcon = <i className='icon icon-list-tick' />
      }

      return (
        <div className='statusinfoitem' key={idx}>
          <div className={_statCls}>{statusIcon}</div>
        </div>
      )
    })
  }

  _renderCloseDate () {
    let closedStatusPhases = 0
    this.data.phases.map(phase => {
      if (phase.status === 'closed') {
        closedStatusPhases++
      }
    })
    if (
      this.data.phases.length - 1 === closedStatusPhases ||
      this.data.phases.length === closedStatusPhases ||
      this.data.projectStatus === 'closed'
    ) {
      const closeDate =
        this.data.closeDate && this.data.closeDate.date
          ? this.data.closeDate.date
          : DateUtil.getUTCCurrentDate()
      return (
        <div className='formrow formrow_date'>
          <div className='formcol2'>
            <FormDatePicker
              label='project.form.projectCloseDate'
              placeholder='project.form.projectCloseDate'
              value={closeDate}
              name='closeDate'
              onChange={this._onChangeDate.bind(this, 'closeDate')}
            />
          </div>
          <div className='formcol2'>
            <FormButton
              title='project.form.actionToday'
              type='text'
              className={`wizard${
                this.data.closeDate && this.data.closeDate.bToday ? '' : 'alt'
              }`}
              onClick={this._onClickDate.bind(this, 'closeDate', 'today')}
            />
            <FormButton
              title='project.form.actionYesterday'
              type='text'
              className={`wizard${
                this.data.closeDate && this.data.closeDate.bToday ? 'alt' : ''
              }`}
              onClick={this._onClickDate.bind(this, 'closeDate', 'yesterday')}
            />
            {(this.data.phases.length === closedStatusPhases ||
              this.data.projectStatus === 'closed') && (
              <FormButton
                title='project.form.actionOk'
                type='text'
                className='wizardalt'
                onClick={this._onClickConfirm.bind(this)}
              />
            )}
          </div>
        </div>
      )
    }

    return ''
  }

  _getTabIndex (value) {
    if (value === 'estimate') {
      return 0
    } else if (value === 'completed') {
      return 2
    } else if (value === 'closed') {
      return 3
    }

    return 1
  }

  _updateProjectStatus (phases) {
    const curStatus = this.data.projectStatus
    const projectPhases = phases.length > 0 ? phases : []

    if (projectPhases && projectPhases.length > 0) {
      let noTotalPhases = 0
      let noActivePhases = 0
      let noEstimatePhases = 0
      let noCompletedPhases = 0
      let noClosedPhases = 0

      projectPhases.map((phase, _phaseIdx) => {
        noTotalPhases++

        if (phase.status === 'estimate') {
          noEstimatePhases++
        } else if (phase.status === 'active') {
          noActivePhases++
        } else if (phase.status === 'completed') {
          noCompletedPhases++
        } else if (phase.status === 'closed') {
          noClosedPhases++
        }
      })

      // If some phases are closed, consider the remaining phase status
      if (noClosedPhases > 0) {
        // If all phases closed
        if (noClosedPhases === noTotalPhases) {
          this.data.projectStatus = 'closed'
        } else {
          this._getNewStatus(
            curStatus,
            noEstimatePhases,
            noActivePhases,
            noCompletedPhases,
            0,
            noTotalPhases - noClosedPhases
          )
        }
      } else {
        this._getNewStatus(
          curStatus,
          noEstimatePhases,
          noActivePhases,
          noCompletedPhases,
          noClosedPhases,
          noTotalPhases
        )
      }
    }
  }

  _getNewStatus (
    curStatus,
    noEstimatePhases,
    noActivePhases,
    noCompletedPhases,
    noClosedPhases,
    noTotalPhases
  ) {
    // If any one phase status is active and project current status = estimate,
    // then change project status to active
    if (
      noActivePhases > 0 &&
      (curStatus === 'estimate' ||
        curStatus === 'completed' ||
        curStatus === 'closed')
    ) {
      this.data.projectStatus = 'active'
    } else if (noCompletedPhases > 0 && curStatus === 'closed') {
      // If any one phase status is completed and project current status = closed,
      // then change project status to completed
      this.data.projectStatus = 'completed'
    } else if (
      noCompletedPhases === noTotalPhases &&
      curStatus !== 'completed'
    ) {
      // If all phase status is completed change project status to completed
      this.data.projectStatus = 'completed'
    } else if (noClosedPhases === noTotalPhases && curStatus !== 'closed') {
      // If all phase status is closed change project status to closed
      this.data.projectStatus = 'closed'
    } else if (noActivePhases <= 0 && curStatus === 'active') {
      // If no phases with active status and current status = active
      this.data.projectStatus = 'estimate'
    } else if (noTotalPhases === 1 && noEstimatePhases === 1) {
      // If no phases is 1 and it is with status estimate, then project status should be estimate
      this.data.projectStatus = 'estimate'
    }

    this.setState({ dataDate: new Date() })
  }

  _isActiveStatusEnabled (curStatus) {
    // If status is completed, we cant make it active any time
    if (curStatus === 'closed') return false

    // Only Project manager, can move status from Completed to active
    if (curStatus === 'completed') {
      return !!Acl.isRoleProjectManager()
    }

    return true
  }

  _isCompleteStatusEnabled (curStatus) {
    // If current status not closed, then we can complete it
    if (curStatus !== 'closed') return true

    // Only Finance User, can open from Closed to complete
    return !!Acl.isRoleFinance()
  }
}

export default ProjectPhaseStatus
